// reduces the opacity of a hex color string by specified amount (0.0 to 1.0).
const transparentize = (amount, color) => {
  const [r, g, b] = color.replace("#", "").match(/([A-Fa-f0-9]{2,2})/g)
  return `rgba(${parseInt(r, 16)}, ${parseInt(g, 16)}, ${parseInt(b, 16)}, ${(1.0 - amount).toFixed(
    2,
  )})`
}

export default transparentize
